<div
    class="inner-content dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow"
    ridangoAppTrapFocus>
    <div class="flex h-14 w-full items-center">
        <div class="align-center my-4 flex-1">
            <h2 class="font-semibold" [ngSwitch]="action" ridangoAutofocus tabindex="-1">
                <ng-container *ngSwitchCase="'RETURN_TICKET'">{{ 'RETURN_TICKET' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'SEND_TICKET'">{{ 'SEND_TICKET' | translate }}</ng-container>
                <ng-container *ngSwitchCase="CONFIRM_EMAIL_SENDING">{{ 'SEND_TICKET' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'LEND_TICKET'">{{ 'LEND_TICKET' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'RETURN_LEND_TICKET'">{{ 'LENT_TICKET_RETURN' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'RECALL_LEND_TICKET'">{{ 'LENT_TICKET_RETURN' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'ACCOUNT_REQUIRED'">{{ 'ACCOUNT_REQUIRED' | translate }}</ng-container>
            </h2>
        </div>
        <div class="absolute right-0" *ngIf="shouldShowCloseButton">
            <button [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate" (click)="cancel()" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="w-full" *ngIf="action === ACCOUNT_REQUIRED">
        <ng-container>
            <div class="text-center">
                <p>{{ 'THE_EMAIL' | translate }}&nbsp;</p>
                <p class="bold">{{ form.controls?.identifier?.value }}&nbsp;</p>
                <p class="mb-4 block">{{ 'IS_NOT_ASSOCIATED_WITH_ANY_VL' | translate }}</p>
                <p class="mb-4 block">{{ 'THE_RECIPIENT_WILL_BE_REQUIRED_TO_CREATE' | translate }}</p>
                <p>{{ 'DO_YOU_WANT_TO_PROCEED' | translate }}</p>
            </div>
            <div class="flex-column">
                <button
                    class="btn--link btn--maximal btn--big link--no-line link--no-hover ng-star-inserted mt-4 rounded-lg text-primary"
                    [attr.aria-label]="'CANCEL' | translate"
                    (click)="cancelSendTicket()">
                    {{ 'CANCEL' | translate }}
                </button>
                <button
                    class="btn--primary h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="'PROCEED' | translate"
                    (click)="sendTicket()">
                    {{ 'PROCEED' | translate }}
                </button>
            </div>
        </ng-container>
    </div>

    <div class="w-full" *ngIf="action === CONFIRM_EMAIL_SENDING">
        <ng-container>
            <div class="text-center">
                <p>{{ 'CONFIRM_SEND_TICKET' | translate }}&nbsp;</p>
                <p class="bold mt-2">{{ form.controls?.identifier?.value }}&nbsp;</p>
                <p class="mt-2">{{ 'CONTINUE_SEND_TICKET' | translate }}</p>
            </div>
            <div class="flex-column">
                <button
                    class="btn--link btn--maximal btn--big link--no-line link--no-hover ng-star-inserted mt-4 rounded-lg text-primary"
                    [attr.aria-label]="'CANCEL' | translate"
                    (click)="cancelSendTicket()">
                    {{ 'CANCEL' | translate }}
                </button>
                <button
                    class="btn--primary h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="'LOCAL_BTN_CONFIRM' | translate"
                    (click)="sendTicket()">
                    {{ 'LOCAL_BTN_CONFIRM' | translate }}
                </button>
            </div>
        </ng-container>
    </div>

    <div class="w-full" *ngIf="action === 'RETURN_TICKET'" [ngClass]="{ 'is-new-afc': env.IS_NEW_AFC }">
        <ng-container *ngIf="anyAllowedTravelCards">
            <form [formGroup]="form" [ngSwitch]="action" (ngSubmit)="submit()">
                <mat-form-field class="mt-2 flex w-full" appearance="outline">
                    <mat-label>{{ 'CHOOSE_EXISTING_CARD' | translate }}</mat-label>
                    <input [matAutocomplete]="auto" matInput formControlName="travelCardNumber" />
                    <mat-icon matSuffix>expand_more</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                        <mat-option *ngFor="let card of travelCards" [value]="card.card_nr">{{ card.name }}</mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="
                            form.controls.travelCardNumber.touched &&
                            form.controls.travelCardNumber.errors?.['required']
                        ">
                        {{ 'TRAVEL_CARD_MUST_BE_SELECTED' | translate }}
                    </mat-error>
                </mat-form-field>
                <ng-container *ngIf="env.IS_NEW_AFC" [ngTemplateOutlet]="cancelButtonTemplate"></ng-container>
                <div class="flex">
                    <button
                        class="h-14 w-full rounded-lg bg-primary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        type="submit">
                        {{ 'RETURN_TICKET' | translate }}
                    </button>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="!anyAllowedTravelCards">
            <div
                class="my-4 flex h-14 w-full flex-row items-center justify-start rounded-lg bg-gray-200 px-4 py-2 text-black dark:bg-gray-700 dark:text-contrast-yellow">
                <mat-icon class="mr-2 !w-8" inline="true" svgIcon="actionInfo"></mat-icon>
                <span class="my-4">{{ 'NO_CARDS_FOUND' | translate }}</span>
            </div>

            <div
                class="btn mt-7 flex h-14 w-full justify-center rounded-lg bg-primary text-white dark:bg-contrast-yellow dark:text-contrast-black"
                (click)="addTravelCard()">
                <mat-icon class="mr-1 !w-8" inline="true" svgIcon="actionAdd"></mat-icon>
                <span class="my-4">{{ 'ADD_NEW_CARD' | translate }}</span>
            </div>
        </ng-container>
    </div>
    <div class="w-full" *ngIf="action === 'SEND_TICKET'">
        <ng-container>
            <ng-container *ngIf="isLoading">
                <ridango-page-content-wrapper id="main-content">
                    <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
                    </ridango-ui-basic-loading-spinner>
                </ridango-page-content-wrapper>
            </ng-container>

            <form [formGroup]="form" [ngSwitch]="action" (ngSubmit)="submit()">
                <mat-form-field class="mt-2 flex w-full" appearance="outline">
                    <mat-label>{{
                        (env.IS_NEW_AFC ? 'LOCAL_LABEL_EMAIL_OR_PHONE' : 'LOCAL_LABEL_EMAIL') | translate
                    }}</mat-label>
                    <input
                        [attr.aria-invalid]="form.controls.identifier.invalid && form.controls.identifier.touched"
                        matInput
                        formControlName="identifier"
                        required="true"
                        ridangoInput
                        aria-errormessage="identifier-error" />
                    <mat-error id="identifier-error" aria-live="polite">
                        <ng-container
                            *ngIf="form.controls.identifier.touched && form.controls.identifier.errors?.required">
                            {{
                                (env.IS_NEW_AFC ? 'MODAL_EMAIL_OR_PHONE_REQUIRED' : 'MODAL_EMAIL_REQUIRED') | translate
                            }}
                        </ng-container>
                        <ng-container
                            *ngIf="
                                form.controls.identifier.touched &&
                                form.controls.identifier.errors &&
                                !form.controls.identifier.errors?.required
                            ">
                            <ng-container *ngIf="form.controls.identifier.errors?.['email']">
                                {{ 'MODAL_EMAIL_NOT_VALID' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['invalidEmail']">
                                {{ 'MODAL_EMAIL_NOT_VALID' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['invalidEmailOrPhone']">
                                {{ 'MODAL_EMAIL_OR_PHONE_NOT_VALID' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['phoneTooShort']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['phoneTooLong']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['invalidPhoneCountryCode']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.identifier.errors?.['invalidPhoneNumber']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}
                            </ng-container>
                        </ng-container>
                    </mat-error>
                </mat-form-field>
                <ng-container
                    *ngIf="shouldShowCloseButton && env.IS_NEW_AFC"
                    [ngTemplateOutlet]="cancelButtonTemplate"></ng-container>
                <div class="flex">
                    <button
                        class="var-app-light:text-black h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                        [ngClass]="{
                            'btn--primary': !isDisableSendTicketButton,
                            'bg-[#F0F0F0]': isDisableSendTicketButton,
                            'var-app-light:opacity-50': isDisableSendTicketButton
                        }"
                        [disabled]="isDisableSendTicketButton || isLoading"
                        type="submit">
                        {{ 'SEND_TICKET' | translate }}
                    </button>
                </div>
            </form>
        </ng-container>
    </div>
    <div
        class="w-full"
        *ngIf="action === 'RETURN_LEND_TICKET' || action === 'RECALL_LEND_TICKET'"
        [ngClass]="{ 'pb-4': env.IS_NEW_AFC }">
        <ng-container>
            <form [formGroup]="form" [ngSwitch]="action" (ngSubmit)="submit()">
                <p class="px-6 text-center">
                    {{ (ticket.isOwner ? 'RETURN_LEND_TICKET_TITLE_OWNER' : 'RETURN_LEND_TICKET_TITLE') | translate }}
                </p>
                <p class="px-3 text-center">
                    {{
                        (ticket.isOwner ? 'RETURN_LEND_TICKET_DESCRIPTION_OWNER' : 'RETURN_LEND_TICKET_DESCRIPTION')
                            | translate
                    }}
                </p>
                <ng-container *ngIf="env.IS_NEW_AFC" [ngTemplateOutlet]="cancelButtonTemplate"></ng-container>
                <div class="flex">
                    <button
                        class="vl-app-light:text-black vl-app-light:bg-[var(--btn-primary-color)] orb-app-light:text-black h-14 w-full rounded-lg bg-[var(--color-brand-primary)] font-bold text-primary dark:bg-contrast-yellow dark:text-contrast-black"
                        type="submit">
                        {{ (ticket.isOwner ? 'REQUEST_TICKET_RETURN' : 'RETURN_TICKET') | translate }}
                    </button>
                </div>
            </form>
        </ng-container>
    </div>

    <div class="w-full" *ngIf="action === 'LEND_TICKET'" [ngClass]="{ 'is-new-afc': env.IS_NEW_AFC }">
        <ng-container>
            <form [formGroup]="form" [ngSwitch]="action" (ngSubmit)="submit()">
                <mat-form-field
                    class="mt-2 flex w-full"
                    [class.padding-empty]="env.SHOW_SELECTOR_TIME_LEND_TICKET"
                    appearance="outline">
                    <mat-label>{{
                        env.IS_NEW_AFC ? ('LOCAL_LABEL_EMAIL_OR_PHONE' | translate) : ('LOCAL_LABEL_EMAIL' | translate)
                    }}</mat-label>
                    <input
                        [attr.aria-invalid]="form.controls.email.invalid && form.controls.email.touched"
                        matInput
                        formControlName="email"
                        required="true"
                        ridangoInput
                        aria-errormessage="email-error" />
                    <mat-error id="email-error" aria-live="polite" tabindex="-1">
                        <ng-container
                            *ngIf="form.controls.email.touched && form.controls.email.errors?.['required']"
                            tabindex="-1">
                            {{ 'MODAL_EMAIL_OR_PHONE_REQUIRED' | translate }}
                        </ng-container>
                        <ng-container
                            *ngIf="
                                form.controls.email.touched &&
                                form.controls.email.errors &&
                                !form.controls.email.errors?.['required']
                            "
                            tabindex="-1">
                            <ng-container *ngIf="form.controls.email.errors?.['invalidEmail']">
                                {{ 'MODAL_EMAIL_NOT_VALID' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.email.errors?.['invalidEmailOrPhone']">
                                {{ 'MODAL_EMAIL_OR_PHONE_NOT_VALID' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.email.errors?.['phoneTooShort']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.email.errors?.['phoneTooLong']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.email.errors?.['invalidPhoneCountryCode']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
                            </ng-container>
                            <ng-container *ngIf="form.controls.email.errors?.['invalidPhoneNumber']">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}
                            </ng-container>
                        </ng-container>
                    </mat-error>
                </mat-form-field>
                <ng-container *ngIf="!env.IS_NEW_AFC">
                    <div
                        class="lend-ticked-date-container mb-6 flex"
                        *ngIf="!env.SHOW_SELECTOR_TIME_LEND_TICKET; else selectorPeriod">
                        <mat-form-field class="flex-2" appearance="outline">
                            <input [value]="validUntilFormatted" [readonly]="true" matInput />
                        </mat-form-field>
                        <button
                            class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black flex-align-center m-0 flex h-[53px] flex-1 justify-center gap-2 rounded-l-none rounded-r-[5px] bg-[var(--color-brand-primary)] font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                            id="set-lend-period"
                            type="button">
                            <mat-icon
                                class="vl-app-light:text-black text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                >schedule</mat-icon
                            >
                            {{ 'MODAL_SET_LEND_PERIOD' | translate }}
                        </button>
                    </div>
                </ng-container>
                <ng-template #selectorPeriod>
                    <button
                        class="period_selector mb-4 box-border flex h-14 w-full items-center justify-between rounded-lg px-4 dark:border-contrast-yellow"
                        (click)="openPeriodModal()"
                        type="button">
                        <ion-label
                            class="text-base font-normal normal-case leading-5"
                            [class.font-bold]="selectedLendTime">
                            {{ selectedLendTime ? selectedLendTime.label : ('CHOOSE_PERIOD_LEND' | translate) }}
                        </ion-label>
                        <ion-icon
                            class="vl-app-light:text-grey-zambezy dark:filter-yellow"
                            name="caret-down"
                            aria-hidden="true"
                            title="{{ 'CHEVRON_DOWN' | translate }}"
                            aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                            size="small"></ion-icon>
                    </button>
                    <div class="position-relative mb-4 text-base font-bold" [class.opacity-0]="!selectedLendTime">
                        {{ ('EXPIRED_LEND' | translate) + ' ' + selectedLendTime?.date }}
                    </div>
                </ng-template>
                <button
                    class="lend-button vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black mt-5 h-14 w-full rounded-lg bg-[var(--color-brand-primary)] font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                    [ngClass]="{ 'bottom-4': env.SHOW_SELECTOR_TIME_LEND_TICKET }"
                    [disabled]="disableLendButton"
                    type="submit">
                    {{ 'LEND_TICKET' | translate }}
                </button>
            </form>
        </ng-container>
    </div>
</div>

<ridango-ui-datetime-select
    *ngIf="action === 'LEND_TICKET'"
    [(ngModel)]="validUntil"
    [triggerId]="'set-lend-period'"
    [minDate]="validUntilMinDate"
    [maxDate]="ticket.ending"
    (ngModelChange)="onLentToChanged()">
</ridango-ui-datetime-select>

<ng-template #cancelButtonTemplate>
    <div class="flex items-center justify-center">
        <button
            class="orb-app-light:text-secondary btn--maximal link--no-line link--no-hover py-4 font-semibold text-primary dark:text-contrast-yellow"
            [attr.aria-label]="'LOCAL_BTN_CANCEL' | translate"
            (click)="cancel()"
            type="button">
            {{ 'LOCAL_BTN_CANCEL' | translate }}
        </button>
    </div>
</ng-template>
